import * as _ from 'lodash';
// import PerfectScrollbar from 'perfect-scrollbar';
import * as moment from 'moment';
declare var require: any;

export const MIN_VALUE_DATE = 0;
export const MAX_VALUE_DATE = 99999999;

export function trackByFn(index, item) {
    return item?.id; // or index
}

export function isUndefinedObjOrString(obj): boolean {
    return typeof obj === 'undefined' || obj === 'undefined';
}

export function isUndefined(obj): boolean {
    return typeof obj === 'undefined';
}

export function isEmptyObject(obj): boolean {
    return obj && Object.keys(obj).length === 0;
}

export function objectToArray(obj: Object): Array<Object> {
    if (!obj) {
        return null;
    }
    const keys = Object.keys(obj);
    const res = [];
    for (let i = 0; i < keys.length; i++) {
        res[i] = { key: keys[i], value: obj[keys[i]] };
    }
    return res;
}

export function toStringByKey(key: string, data: Array<any>, separator: string = ','): string {
    let i: number;
    let res: string;

    res = '';
    for (i = 0; i < data.length; i++) {
        if (!res) {
            res = data[i][key];
        } else {
            res += separator + data[i][key];
        }
    }

    return res;
}

export function buildArrayByKey(key: string, data: Array<any>): Array<any> {
    let i: number;
    const res_arr: Array<any> = [];
    let val: any;

    for (i = 0; i < data.length; i++) {
        val = data[i][key];

        if (!res_arr[val]) {
            res_arr[val] = [];
        }

        res_arr[val].push(data[i]);
    }
    return res_arr;
}

export function indexOfArrayByKey(key: string, value: any, data: Array<any>): number {
    let i: number = 0;

    while (data && i < data.length) {
        if (value == data[i][key] || value == Number(data[i][key])) {
            return i;
        }

        i++;
    }

    return -1;
}

export function isKeyNumber(keyCode: number): boolean {
    const allows_arr: Array<number> = [48, 49, 50, 51, 52, 53, 54, 55, 56, 57];
    // console.log("val: ", allows_arr.indexOf(ev.keyCode));
    if (allows_arr.indexOf(keyCode) >= 0) {
        return true;
    } else {
        return false;
    }
}

export function deepClone(object: Object): Object {
    return _.cloneDeep(object);
}

export function objEquals(obj1: Object, obj2: Object): boolean {
    return _.isEqual(obj1, obj2);
}

export function isBaseUrl(url: string): boolean {
    return url.startsWith('http://') || url.startsWith('https://');
}

export function isValidEmail(email: string): boolean {
    return /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
        email
    );
}

export function decodeJwt(token) {
    const base64 = token.split('.')[1].replace('-', '+').replace('_', '/');
    return JSON.parse(atob(base64));
}

export function newFromJson<T>(json: string, Type: { new (Object): T }): T | T[] {
    try {
        if (!json) {
            return null;
        }
        const parsed = JSON.parse(json);
        if (parsed instanceof Array) {
            return parsed.map((u) => new Type(u));
        }
        return new Type(parsed);
    } catch (e) {
        console.error(`Error parsing JSON array to ${Type.name}.`);
    }
    return null;
}

export function cleanUndefined(obj: Object) {
    const obj2 = Object.assign({}, obj);
    for (const key in obj) {
        if (obj[key] === undefined) {
            delete obj2[key];
        }
    }
    return obj2;
}

export function triggerOnResizeDelay() {
    const DELAY: number = 400;
    setTimeout(() => {
        window.dispatchEvent(new Event('resize'));
    }, DELAY);
}

export function getTodaySubtract(daysSubstract: number) {
    const today = moment();
    return today.subtract(daysSubstract, 'day');
}

export function getMinDate() {
    return moment('1950-01-01');
}

export function dateCheck(from, to, check) {
    let fDate, lDate, cDate;
    fDate = Date.parse(from);
    lDate = Date.parse(to);
    cDate = Date.parse(check);

    if (cDate <= lDate && cDate >= fDate) {
        return true;
    }
    return false;
}

export function getValueBrackets(str: string) {
    return str.match(/\(([^)]+)\)/)[1];
}

export function getBaseUrl(url: string) {
    const urlArr = url ? url.split('?') : null;
    return urlArr && urlArr.length ? urlArr[0] : url;
}

// export function getLinesCart(cart: CartState) {
//     const SEPARATOR_REGISTER: string = '##';
//     const SEPARATOR_VALUE: string = '=>';
//     const SEPARATOR_FIELD: string = '&&';
//     // ARTICULO=>114170&&CANTIDAD=>4&&PRECIO=>50&&DTO1=>0&&DTO2=>0&&DTO3=>0##AR
//     let str: string = '';
//     let i: number;

//     let items = CartHelper.getItems(cart.cart);
//     for (i = 0; i < items.length; i++) {
//         str += 'ARTICULO' + SEPARATOR_VALUE + items[i].product_id + SEPARATOR_FIELD +
//             'CANTIDAD' + SEPARATOR_VALUE + items[i].quantity + SEPARATOR_FIELD +
//             'PRECIO' + SEPARATOR_VALUE + items[i].price + SEPARATOR_FIELD +
//             'DTO1' + SEPARATOR_VALUE + 0 + SEPARATOR_FIELD +
//             'DTO2' + SEPARATOR_VALUE + 0 + SEPARATOR_FIELD +
//             'DTO3' + SEPARATOR_VALUE + 0;

//         if (i < items.length - 1) {
//             str += SEPARATOR_REGISTER;
//         }
//     }
//     // console.log("Antes de cofigicar: ", str);
//     const b64cad = Base64.encode(str);
//     return b64cad;
// }

export function getAuthString(email: string, password: string, domain: string, publicKey: string) {
    const fecha = moment().format('YYYYMMDD');
    const cad = cifrarXor(email + '|' + password + '|' + domain + '|' + fecha, publicKey);
    const b64cad = Base64.encode(cad);
    return b64cad;
}

/**
 * @brief     Encrypt a value with password
 *
 * @param      value      Value to encrypt
 * @param      password   Password to encrypt
 *
 * @return     Encrypted value
 */
export function cifrarXor(value: string, password: string): string {
    let i = 0;
    let j = 0;
    let sCifrado = '';
    if (undefined == password) password = '';
    while (i < value.length) {
        sCifrado += String.fromCharCode(value.charCodeAt(i) ^ password.charCodeAt(j));
        j = (j + 1) % password.length;
        i++;
    }

    return sCifrado;
}

/* -------------------------------------------------------------------
 * Base64
 * -------------------------------------------------------------------
 */
export var Base64 = {
    _keyStr: 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=',

    encode: function (input) {
        var output = '';
        var chr1, chr2, chr3, enc1, enc2, enc3, enc4;
        var i = 0;

        input = Base64._utf8_encode(input);

        while (i < input.length) {
            chr1 = input.charCodeAt(i++);
            chr2 = input.charCodeAt(i++);
            chr3 = input.charCodeAt(i++);

            enc1 = chr1 >> 2;
            enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
            enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
            enc4 = chr3 & 63;

            if (isNaN(chr2)) {
                enc3 = enc4 = 64;
            } else if (isNaN(chr3)) {
                enc4 = 64;
            }

            output =
                output +
                this._keyStr.charAt(enc1) +
                this._keyStr.charAt(enc2) +
                this._keyStr.charAt(enc3) +
                this._keyStr.charAt(enc4);
        }

        return output;
    },

    decode: function (input) {
        var output = '';
        var chr1, chr2, chr3;
        var enc1, enc2, enc3, enc4;
        var i = 0;

        input = input.replace(/[^A-Za-z0-9\+\/\=]/g, '');

        while (i < input.length) {
            enc1 = this._keyStr.indexOf(input.charAt(i++));
            enc2 = this._keyStr.indexOf(input.charAt(i++));
            enc3 = this._keyStr.indexOf(input.charAt(i++));
            enc4 = this._keyStr.indexOf(input.charAt(i++));

            chr1 = (enc1 << 2) | (enc2 >> 4);
            chr2 = ((enc2 & 15) << 4) | (enc3 >> 2);
            chr3 = ((enc3 & 3) << 6) | enc4;

            output = output + String.fromCharCode(chr1);

            if (enc3 != 64) {
                output = output + String.fromCharCode(chr2);
            }
            if (enc4 != 64) {
                output = output + String.fromCharCode(chr3);
            }
        }

        output = Base64._utf8_decode(output);

        return output;
    },

    _utf8_encode: function (string) {
        string = string.replace(/\r\n/g, '\n');
        var utftext = '';

        for (var n = 0; n < string.length; n++) {
            var c = string.charCodeAt(n);

            if (c < 128) {
                utftext += String.fromCharCode(c);
            } else if (c > 127 && c < 2048) {
                utftext += String.fromCharCode((c >> 6) | 192);
                utftext += String.fromCharCode((c & 63) | 128);
            } else {
                utftext += String.fromCharCode((c >> 12) | 224);
                utftext += String.fromCharCode(((c >> 6) & 63) | 128);
                utftext += String.fromCharCode((c & 63) | 128);
            }
        }

        return utftext;
    },

    _utf8_decode: function (utftext) {
        var string = '';
        var i = 0;
        var c1, c2, c3;
        var c = (c1 = c2 = 0);

        while (i < utftext.length) {
            c = utftext.charCodeAt(i);

            if (c < 128) {
                string += String.fromCharCode(c);
                i++;
            } else if (c > 191 && c < 224) {
                c2 = utftext.charCodeAt(i + 1);
                string += String.fromCharCode(((c & 31) << 6) | (c2 & 63));
                i += 2;
            } else {
                c2 = utftext.charCodeAt(i + 1);
                c3 = utftext.charCodeAt(i + 2);
                string += String.fromCharCode(((c & 15) << 12) | ((c2 & 63) << 6) | (c3 & 63));
                i += 3;
            }
        }

        return string;
    },
};

export function isViewportTablet() {
    const BREAK_WIDTH = 1200;
    return window.innerWidth < BREAK_WIDTH;
}

export function isViewportProductCard() {
    const BREAK_WIDTH = 1200;
    return window.innerWidth < BREAK_WIDTH;
}

// $mobile-breakpoint (ajustar con el punto de corte usado en maqueta)
export function isViewportMobile() {
    const BREAK_WIDTH = 768;
    return window.innerWidth < BREAK_WIDTH;
}

export function isMobile() {
    return navigator.userAgent.match(/(iPad)|(iPhone)|(iPod)|(android)|(webOS)/i);
}

export function isiOS() {
    return navigator.userAgent.match(/(iPad)|(iPhone)|(iPod)/i);
}

export function isFirefox() {
    return navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
}

export function isIE() {
    const ua = window.navigator.userAgent;
    const msie = ua.indexOf('MSIE ');
    return msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./);
}

export function isEdge() {
    if (/Edge\/\d./i.test(navigator.userAgent)) {
        // This is Microsoft Edge
        return true;
    } else {
        return false;
    }
}

export function getUserAgent() {
    return navigator.userAgent;
}

export function ieVersion(versionToCheck: number = 10): boolean {
    let retorno = false;
    const userAgent = navigator.userAgent;

    userAgent.split(';').filter((value, index) => {
        if (value.indexOf('MSIE') >= 0) {
            const userAgentIeParts = value.trim().split(' ');
            if (versionToCheck >= parseFloat(userAgentIeParts[1])) {
                retorno = true;
            }
        }
    });

    return retorno;
}

export function checkChromeVersion(versionToCheck: number = 49): boolean {
    let retorno = false;
    const userAgent = navigator.userAgent;

    userAgent.split(' ').filter((value, index) => {
        if (value.indexOf('Chrome') >= 0) {
            const userAgentChromeParts = value.split('/');
            if (versionToCheck >= parseFloat(userAgentChromeParts[1])) {
                retorno = true;
            }
        }
    });

    return retorno;
}

export function addHostDomain(url: string): string {
    url = window.location.protocol + '//' + window.location.hostname + url;
    window['nombrePagina'] = url;
    return url;
}

/* -------------------------------------------------------------------
 * Soledad utils
 * -------------------------------------------------------------------
 */
export var SoledadUtils = {
    getAuthString(email: string, password: string, domain: string, publicKey: string) {
        const fecha = moment().format('YYYYMMDD');
        const cad = this.cifrarXor(email + '@' + password + '@' + domain + '@' + fecha, publicKey);
        const b64cad = Base64.encode(cad);
        return b64cad;
    },

    getUrlRedirectString(
        email: string,
        password: string,
        domain: string,
        publicKey: string,
        rememberLoginChecked: boolean = false
    ) {
        const fecha = moment().format('YYYYMMDD');
        const cad = this.cifrarXor(
            email + '@' + password + '@' + domain + '@' + fecha + '@' + rememberLoginChecked,
            publicKey
        );
        const b64cad = Base64.encode(cad);
        return b64cad;
    },

    /**
     * @brief     Encrypt a value with password
     *
     * @param      value      Value to encrypt
     * @param      password   Password to encrypt
     *
     * @return     Encrypted value
     */
    cifrarXor(value: string, password: string): string {
        var i = 0;
        var j = 0;
        var sCifrado = '';
        if (undefined == password) password = '';
        while (i < value.length) {
            sCifrado += String.fromCharCode(value.charCodeAt(i) ^ password.charCodeAt(j));
            j = (j + 1) % password.length;
            i++;
        }

        return sCifrado;
    },

    dateTimeParse(sDate: string): Date {
        if (!sDate) return null;
        try {
            let dateAux = new Date();
            eval('dateAux = new ' + sDate.substring(1, sDate.length - 1));
            return dateAux;
        } catch (err) {
            return null;
        }
    },
};

export function toSafeImgUrl(string: string): string {
    return encodeURIComponent(string.trim().replace(/\s+/g, '-').replace(/\*+/g, '').toLowerCase());
}

export function getObjectDiff(obj1, obj2, compareRef = false) {
    if (!obj1) return [];
    return Object.keys(obj1).reduce((result, key) => {
        if (!obj2.hasOwnProperty(key)) {
            result.push(key);
        } else if (_.isEqual(obj1[key], obj2[key])) {
            const resultKeyIndex = result.indexOf(key);

            if (compareRef && obj1[key] !== obj2[key]) {
                result[resultKeyIndex] = `${key} (ref)`;
            } else {
                result.splice(resultKeyIndex, 1);
            }
        }
        return result;
    }, Object.keys(obj2));
}

/**
 * Secure Hash Algorithm (SHA1)
 * http://www.webtoolkit.info/
 **/
export function sha1(msg) {
    function rotate_left(n, s) {
        var t4 = (n << s) | (n >>> (32 - s));
        return t4;
    }
    function cvt_hex(val) {
        var str = '';
        var i;
        var v;
        for (i = 7; i >= 0; i--) {
            v = (val >>> (i * 4)) & 0x0f;
            str += v.toString(16);
        }
        return str;
    }
    function Utf8Encode(string) {
        string = string.replace(/\r\n/g, '\n');
        var utftext = '';
        for (var n = 0; n < string.length; n++) {
            var c = string.charCodeAt(n);
            if (c < 128) {
                utftext += String.fromCharCode(c);
            } else if (c > 127 && c < 2048) {
                utftext += String.fromCharCode((c >> 6) | 192);
                utftext += String.fromCharCode((c & 63) | 128);
            } else {
                utftext += String.fromCharCode((c >> 12) | 224);
                utftext += String.fromCharCode(((c >> 6) & 63) | 128);
                utftext += String.fromCharCode((c & 63) | 128);
            }
        }
        return utftext;
    }
    var blockstart;
    var i, j;
    var W = new Array(80);
    var H0 = 0x67452301;
    var H1 = 0xefcdab89;
    var H2 = 0x98badcfe;
    var H3 = 0x10325476;
    var H4 = 0xc3d2e1f0;
    var A, B, C, D, E;
    let temp: string;
    msg = Utf8Encode(msg);
    var msg_len = msg.length;
    var word_array = new Array();
    for (i = 0; i < msg_len - 3; i += 4) {
        j =
            (msg.charCodeAt(i) << 24) |
            (msg.charCodeAt(i + 1) << 16) |
            (msg.charCodeAt(i + 2) << 8) |
            msg.charCodeAt(i + 3);
        word_array.push(j);
    }
    switch (msg_len % 4) {
        case 0:
            i = 0x080000000;
            break;
        case 1:
            i = (msg.charCodeAt(msg_len - 1) << 24) | 0x0800000;
            break;
        case 2:
            i = (msg.charCodeAt(msg_len - 2) << 24) | (msg.charCodeAt(msg_len - 1) << 16) | 0x08000;
            break;
        case 3:
            i =
                (msg.charCodeAt(msg_len - 3) << 24) |
                (msg.charCodeAt(msg_len - 2) << 16) |
                (msg.charCodeAt(msg_len - 1) << 8) |
                0x80;
            break;
    }
    word_array.push(i);
    while (word_array.length % 16 != 14) word_array.push(0);
    word_array.push(msg_len >>> 29);
    word_array.push((msg_len << 3) & 0x0ffffffff);
    for (blockstart = 0; blockstart < word_array.length; blockstart += 16) {
        for (i = 0; i < 16; i++) W[i] = word_array[blockstart + i];
        for (i = 16; i <= 79; i++) W[i] = rotate_left(W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16], 1);
        A = H0;
        B = H1;
        C = H2;
        D = H3;
        E = H4;
        for (i = 0; i <= 19; i++) {
            temp = ((rotate_left(A, 5) + ((B & C) | (~B & D)) + E + W[i] + 0x5a827999) & 0x0ffffffff).toString();
            E = D;
            D = C;
            C = rotate_left(B, 30);
            B = A;
            A = temp;
        }
        for (i = 20; i <= 39; i++) {
            temp = ((rotate_left(A, 5) + (B ^ C ^ D) + E + W[i] + 0x6ed9eba1) & 0x0ffffffff).toString();
            E = D;
            D = C;
            C = rotate_left(B, 30);
            B = A;
            A = temp;
        }
        for (i = 40; i <= 59; i++) {
            temp = (
                (rotate_left(A, 5) + ((B & C) | (B & D) | (C & D)) + E + W[i] + 0x8f1bbcdc) &
                0x0ffffffff
            ).toString();
            E = D;
            D = C;
            C = rotate_left(B, 30);
            B = A;
            A = temp;
        }
        for (i = 60; i <= 79; i++) {
            temp = ((rotate_left(A, 5) + (B ^ C ^ D) + E + W[i] + 0xca62c1d6) & 0x0ffffffff).toString();
            E = D;
            D = C;
            C = rotate_left(B, 30);
            B = A;
            A = temp;
        }
        H0 = (H0 + A) & 0x0ffffffff;
        H1 = (H1 + B) & 0x0ffffffff;
        H2 = (H2 + C) & 0x0ffffffff;
        H3 = (H3 + D) & 0x0ffffffff;
        H4 = (H4 + E) & 0x0ffffffff;
    }
    temp = cvt_hex(H0) + cvt_hex(H1) + cvt_hex(H2) + cvt_hex(H3) + cvt_hex(H4);

    return temp.toLowerCase();
}

export function getDaysToDate(date: Date) {
    const fechaActual = new Date(); // Fecha de hoy
    // Calcula la diferencia en milisegundos
    const diferenciaEnMilisegundos = date.getTime() - fechaActual.getTime();
    // Convierte la diferencia a días
    const milisegundosPorDia = 1000 * 60 * 60 * 24;
    return Math.ceil(diferenciaEnMilisegundos / milisegundosPorDia);
}

export function getMonthName(month: number) {
    const months = [
        'enero',
        'febrero',
        'marzo',
        'abril',
        'mayo',
        'junio',
        'julio',
        'agosto',
        'septiembre',
        'octubre',
        'noviembre',
        'diciembre',
    ];
    return months[month - 1];
}
